import { useEffect, useState } from 'react';
import { useNavigation } from 'react-router';

/**
 * Een dun streepje bovenaan zolang er een navigatie loopt.
 *
 * WAAROM DIT ER MOET ZIJN. Bij een gewone <a href> tekent de browser zelf een
 * laadindicatie in het tabblad. Zodra de publieke schil op <Link> staat is dat
 * weg: de klik gaat door React Router, de oude pagina blijft staan terwijl de
 * loader draait, en er is geen enkel teken dat er iets gebeurt. Bij een
 * artikelpagina van 30ms merk je dat niet, bij een zoekopdracht over 629
 * artikelen wél — en dan voelt de klik dood.
 *
 * De drempel van 180ms is het hele punt: alles wat sneller klaar is dan dat
 * mag NIETS laten zien. Een balk die verschijnt en meteen weer weg is leest
 * als geflikker, en dat is erger dan geen balk.
 *
 * `state` is 'loading' bij navigatie en 'submitting' bij een formulier; beide
 * verdienen de balk. 'idle' zet hem direct uit — niet uitfaden, want de
 * paginawissel zelf is dan al aan het overvloeien.
 */
export function NavProgress() {
  const { state } = useNavigation();
  const [zichtbaar, setZichtbaar] = useState(false);

  useEffect(() => {
    if (state === 'idle') {
      setZichtbaar(false);
      return;
    }
    const t = setTimeout(() => setZichtbaar(true), 180);
    return () => clearTimeout(t);
  }, [state]);

  if (!zichtbaar) return null;

  // aria-hidden: schermlezers krijgen de nieuwe pagina zelf al aangekondigd,
  // en een balk zonder waarde valt daar niet uit te lezen.
  return <div className="kb-nav-progress" aria-hidden />;
}
